type Props = {
  id?: string;
  children?: React.ReactNode;
  onDeletion: () => void;
  direction?: "row" | "col";
  level: number;
};

//  @function ProducerCell
//  Renders a container used to display a triggers grouping, wgith a built-in button to create a new Cell component
//  @param {string} id - ID used to recognize the container itself
//  @param {string} background - changes the container's background color
//  @param {string} color - changes the add button's icon color (used for high-contrast theming)
//  @param {React.Node} children - content of the container
//  @param {function} onNew - function called everytime the add button is pressed upon
//  @param {string}  direction - sets the direction of the elements inside the cell
//  @param {number}  level - level of condition, to choose color of background
//  @returns {React.Node}
export default function ProducerCell({
  id,
  children,
  onDeletion,
  direction = "row",
  level,
}: Props) {
  const background = level % 2 === 0 ? "#1D1E1C" : "#383838";
  return (
    <div
      className={`flex flex-${direction} items-center w-fit h-fit p-4 relative m-2 `}
      style={{ backgroundColor: background }}
    >
      <div
        id={`${id}_deleter`}
        className="self-end select-none absolute top-0 right-0 cursor-pointer w-4 h-4 leading-4 text-center -mb-2 mr-1 z-30 rounded-full bg-gray-500 text-white"
        onClick={onDeletion}
      >
        ×
      </div>
      <div className={`w-full flex flex-${direction} items-center`}>
        {children}
      </div>
    </div>
  );
}
